<template>
  <div class="parent-box">
    <div class="content">
      <div class="contianer" @click="toTrygame">
        <img src="../../assets/prizeTask/demoTask.png" alt="">
        <div>
          <p>试玩有奖</p>
          <p>参与试玩有奖，领取<span>余额</span>奖励</p>
        </div>
      </div>
      <div class="contianer" @click="toInviate">
        <img src="../../assets/prizeTask/inviateTask.png" alt="">
        <div>
          <p>邀请有奖</p>
          <p>邀请好友送豪礼，领取<span>余额</span>奖励</p>
        </div>
      </div>
      <div class="contianer" @click="toExchange">
        <img src="../../assets/prizeTask/exchangeTask.png" alt="">
        <div>
          <p>兑换有奖</p>
          <p>输入福利码CDK，兑换<span>余额</span>奖励</p>
        </div>
      </div>

      <!-- <div class="contianer" @click="goBindWx">
        <img src="../../assets/prizeTask/bdWx.png" alt="">
        <div>
          <p>绑定微信</p>
          <p>成功绑定并关注，领取<span>余额</span>奖励</p>
        </div>
      </div> -->

    </div>
  </div>
</template>
  
<script>
import { reactive, ref, onActivated } from "vue";
import { useRoute, useRouter } from "vue-router";
import { detect } from "@/utils/device";
import { getQueryString } from "../../utils/location";
export default {
  name: "prizeTask",
  setup() {
    const active = ref(0);
    const route = useRoute();
    const router = useRouter();
    const state = reactive({
      title: route.query.title,
      imageUrl: route.query.imageUrl,
      withdrawal: "0",
      count: 0,
      showRuleDialog: false,
    });

    const toInviate = () => {
      window.document.location =
        "goShare://"
    };
    const toTrygame = () => {
      window.document.location = "gotry://"
    }
    const toExchange = () => {
      window.document.location = "exchangecode://"
    }

    const goBindWx = () => {
      router.push({
          path: "/public/bdWeiXin",
          query: {
            url: "http://yun.zhiquyx.com/appview/user/wxguide" +
              "?token=" +
             getQueryString('token'),
            title: "绑定微信"
          },
        });
    }
    // onActivated(() => {
    //   console.log("get token = " + getQueryString("token"));
    // });

    return {
      state,
      toInviate,
      toExchange,
      toTrygame,
      goBindWx
    };
  },
};
</script>
  
<style scoped>
.nav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 88px;
  width: 100%;
  position: sticky;
  top: 50px;
  z-index: 999;
  padding: 0 20px;
}

.nav .text {
  font-size: 30px;
  color: #664FC3;
}

.nav img {
  height: 50px;
  width: 50px;
}

.parent-box {
  width: 100%;
  height: 100vh;
  padding-top: 58px;
  /* padding-bottom: 200px; */
  background-color: #f7f8fa;
}

.content .contianer {
  width: 686px;
  height: 184px;
  background-color: #fff;
  margin-bottom: 28px;
  margin-top: 40px;
  margin-left: 32px;
  border-radius: 24px;
  display: flex;
  align-items: center;
  padding-left: 40px;
}

.content .contianer img {
  width: 80px;
  height: 80px;
  margin-right: 40px;
}

.content .contianer p:nth-of-type(1) {
  font-size: 32px;
  color: #000;
  font-weight: bold;
  margin-bottom: 8px;
}

.content .contianer p:nth-of-type(2) {
  font-size: 24px;
  color: #8F9197;
}

.content .contianer p:nth-of-type(2) span {
  color: #12CEC7;
  font-weight: 500;
}</style>
  